export default __webpack_public_path__ + "static/media/LinkedIn.f853ba27.svg";